module.exports = __webpack_public_path__ + "static/media/review.91670be0.png";